import axios from 'axios'
import { getAuthHeader } from './config'

const baseURL = '/users'
const prefixURL = '/api'

const register = async (credentials) => {
  const response = await axios.post(
    `${prefixURL}${baseURL}/register`,
    credentials
  )
  return response.data
}

const getAllInstructors = async () => {
  const response = await axios.get(
    `${prefixURL}${baseURL}/getallinstructors`,
    getAuthHeader()
  )
  return response.data
}

const toggleUserStatus = async (userId) => {
  const response = await axios.patch(
    `${prefixURL}${baseURL}/${userId}/toggle-status`,
    undefined,
    getAuthHeader()
  )
  return response.data
}

const requestOtp = async (credentials) => {
  const response = await axios.post(`${prefixURL}${baseURL}/requestotp`, credentials)
  return response.data
}

const verifyOtp = async (credentials) => {
  const response = await axios.post(`${prefixURL}${baseURL}/verifyotp`, credentials)
  return response.data
}

const logout = async () => {
  await axios.post(`${prefixURL}${baseURL}/logout`, undefined, getAuthHeader())
}

const update = async (user) => {
  const formData = new FormData()

  const payload = {
    name: user.name,
    email: user.email,
    mobile: user.mobile,
    username: user.username
  }

  formData.append('obj', JSON.stringify(payload))

  if (user.photo instanceof File) {
    formData.append('file', user.photo)
  }

  const response = await axios.patch(
    `${prefixURL}${baseURL}/me`,
    formData,
    getAuthHeader()
  )

  return response.data
}

const forgotPassword = async (email) => {
  const response = await axios.post(`${prefixURL}${baseURL}/forgot-password`, {
    email
  })
  return response.data
}

const reset = async (token) => {
  const response = await axios.get(
    `${prefixURL}${baseURL}/reset-password/${token}`
  )
  return response.data
}

const resetPassword = async (token, password) => {
  const response = await axios.post(
    `${prefixURL}${baseURL}/reset-password/${token}`,
    { password }
  )
  return response.data
}

const usersService = {
  register,
  getAllInstructors,
  toggleUserStatus,
  requestOtp,
  verifyOtp,
  logout,
  update,
  forgotPassword,
  reset,
  resetPassword
}
export default usersService
